/**
 * AuthorizedRoute - Route with comprehensive protection
 * Maps error codes to appropriate redirects
 */

import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function AuthorizedRoute({ children }) {
  const { currentUser, mongoUser } = useAuth();
  const location = useLocation();

  // Basic authentication check
  if (!currentUser) {
    return <Navigate to="/authenticatie/inloggen" replace state={{ from: location }} />;
  }

  // Authorization checks
  if (!mongoUser) {
    return <Navigate to="/authorizatie/laadscherm" replace state={{ from: location }} />;
  }
  if (mongoUser.hasAcceptedTerms === false) {
    return <Navigate to="/portaal/voorwaarden" replace state={{ from: location }} />;
  }

  if (currentUser.emailVerified === false) {
    return <Navigate to="/authorizatie/email-verificatie" replace state={{ from: location }} />;
  }

  // All checks passed, render the children
  return children;
}

AuthorizedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
